import React from 'react';
import { Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface TemplateLoadDialogProps {
  visible: boolean;
  onAppend: () => void;
  onReplace: () => void;
  onCancel: () => void;
}

const TemplateLoadDialog: React.FC<TemplateLoadDialogProps> = ({ visible, onAppend, onReplace, onCancel }) => (
  <Modal
    open={visible}
    onCancel={onCancel}
    footer={[
      <Button key="append" type="primary" onClick={onAppend}>Append</Button>,
      <Button key="replace" danger onClick={onReplace}>Replace</Button>,
      <Button key="cancel" onClick={onCancel}>Cancel</Button>,
    ]}
  >
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: '0.5rem', fontSize: '1.25rem' }} />
      <b>Load Template / Prior Report</b>
    </div>
    <div style={{ marginTop: '0.75rem' }}>
      Do you want to replace the current content or append this template?
    </div>
  </Modal>
);

export default TemplateLoadDialog;
